import { render, staticRenderFns } from "./diagnosis.vue?vue&type=template&id=556cffa0&scoped=true"
import script from "./diagnosis.vue?vue&type=script&lang=js"
export * from "./diagnosis.vue?vue&type=script&lang=js"
import style0 from "./diagnosis.vue?vue&type=style&index=0&id=556cffa0&lang=scss&scoped=true"
import style1 from "./diagnosis.vue?vue&type=style&index=1&id=556cffa0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556cffa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556cffa0')) {
      api.createRecord('556cffa0', component.options)
    } else {
      api.reload('556cffa0', component.options)
    }
    module.hot.accept("./diagnosis.vue?vue&type=template&id=556cffa0&scoped=true", function () {
      api.rerender('556cffa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report-download/components/diagnosis.vue"
export default component.exports